import React, {useEffect} from "react";
import {useIntl} from "react-intl";
import {useDispatch} from "react-redux";
import {Button, Checkbox, Form, Input} from "antd";
import {Link} from "react-router-dom";

import IntlMessages from "util/IntlMessages";
import {useAuth} from "../authentication";
import AppNotificationContainer from "../components/AppNotificationContainer";
import {switchLanguage} from "../appRedux/actions";
import languageData from "./Topbar/languageData";

const SignUp = () => {
    const {userSignup} = useAuth();
    const intl = useIntl();
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    useEffect(() => {
        if (!localStorage.getItem('locale')) {
            const browserLang = navigator.language.split('-')[0];
            const matched = languageData.find(lang => lang.locale === browserLang);
            dispatch(switchLanguage(matched || languageData[0]));
        }
    }, []);

    const onFinishFailed = errorInfo => {
    };

    const onFinish = values => {
        userSignup(values);
        form.resetFields()
    };

    return (
        <div className="gx-app-login-wrap">
            <div className="gx-app-login-container">
                <div className="gx-app-login-main-content">
                    <div className="gx-app-logo-content">
                        <div className="gx-app-logo-content-bg">
                        </div>
                        <div className="gx-app-logo-wid" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h1><IntlMessages id="app.userAuth.signUp"/></h1>
                            {/*<p><IntlMessages id="app.userAuth.bySigning"/></p>*/}
                            {/*<p><IntlMessages id="app.userAuth.getAccount"/></p>*/}
                        </div>
                    </div>

                    <div className="gx-app-login-content">
                        <Form
                            form={form}
                            initialValues={{remember: true}}
                            name="basic"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            className="gx-signin-form gx-form-row0">
                            <Form.Item style={{marginBottom: 0}}>
                                <Form.Item name="first_name"
                                           rules={[{required: true, message: intl.formatMessage({id: 'app.userAuth.firstNameRequired'})}]}
                                           style={{display: 'inline-block', width: 'calc(50% - 8px)'}}
                                >
                                    <Input placeholder={intl.formatMessage({id: 'app.userAuth.firstNamePlaceholder'})}/>
                                </Form.Item>
                                <Form.Item name="last_name"
                                           rules={[{required: false}]}
                                           style={{
                                               display: 'inline-block',
                                               width: 'calc(50% - 8px)',
                                               margin: '0 8px',
                                               float: 'right'
                                           }}
                                           labelAlign='left'
                                >
                                    <Input placeholder={intl.formatMessage({id: 'app.userAuth.lastNamePlaceholder'})}/>
                                </Form.Item>
                            </Form.Item>
                            <Form.Item name="email"
                                       rules={[{
                                           required: true, type: 'email',
                                           message: intl.formatMessage({id: 'app.userAuth.invalidEmail'}),
                                       }]}
                            >
                                <Input placeholder={intl.formatMessage({id: 'appModule.email'})}/>
                            </Form.Item>
                            <Form.Item name="password"
                                       rules={[{required: true, message: intl.formatMessage({id: 'app.userAuth.requiredPassword'})}]}
                            >
                                <Input type="password" placeholder={intl.formatMessage({id: 'appModule.password'})}/>
                            </Form.Item>
                            <Form.Item
                                name="re_password"
                                dependencies={['password']}
                                rules={[
                                    {
                                        required: true,
                                        message: intl.formatMessage({id: 'app.userAuth.requiredConfirmPassword'}),
                                    },
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error(intl.formatMessage({id: 'app.userAuth.passwordMismatch'})));
                                        },
                                    }),
                                ]}
                            >
                                <Input type="password" placeholder={intl.formatMessage({id: 'app.userAuth.confirmPasswordPlaceholder'})}/>
                            </Form.Item>
                            <Form.Item>
                                <Form.Item name="remember" valuePropName="checked" noStyle>
                                    <Checkbox><IntlMessages id="app.userAuth.rememberMe"/></Checkbox>
                                </Form.Item>
                                <Link style={{float: "right"}} to="/forgot-password">
                                    <IntlMessages id="app.userAuth.forgotPassword"/>
                                </Link>
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" className="gx-mb-0" htmlType="submit">
                                    <IntlMessages id="app.userAuth.signUp"/>
                                </Button>
                                <span><IntlMessages id="app.userAuth.or"/></span> <Link to="/signin"><IntlMessages
                                id="app.userAuth.signIn"/></Link>
                            </Form.Item>
                        </Form>
                    </div>
                    <AppNotificationContainer/>
                </div>
            </div>
            {/*<div className="visa-card-logo">*/}
            {/*    <img alt="Visa" src="/images/visa-mastercard.png"/>*/}
            {/*</div>*/}
        </div>
    );
};

export default SignUp;
